import { InfoCircleFilled, ProfileOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import LastActivity from "../../Last_Activity/LastActivity";
import CRRAnswerModule from "./CRRAnswerModule";
import { useSelector } from "react-redux";
import { DrawerComponent } from "../../Drawer/DrawerComponent";
import QuestionInfo from "../QuestionInfo";

const QuestionModule = ({
  qnObj,
  setAnswer,
  submittedQn,
  isAdminView,
  ...rest
}) => {
  const {
    id,
    order,
    question,
    has_question_subcategory,
    subcategories,
    previous_submission,
    references,
  } = qnObj;
  const [refDescription, setRefDescription] = useState("");
  const [refName, setRefName] = useState("");
  const { questionData: submittedQnData } = useSelector(
    (state) => state.CRRsurvey
  );
  const [lastUpdated, setLastUpdated] = useState({});
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);

  useEffect(() => {
    {
      references.forEach((ref) => {
        if (ref?.type === "CERT-RMM Reference") {
          setRefName(ref?.name);
          setRefDescription(ref?.description);
        }
      });
    }
  }, [references]);

  const infoTitle = () => {
    return references.map((ref) => (
      <div className="info-toolTip-wrapper">
        <span>
          {" "}
          <b>{ref?.type}</b>: {ref?.name}
        </span>
      </div>
    ));
  };
  const handleInfoClick = () => {
    setIsDrawerVisible(true);
  };

  return (
    <div className="question-module-wrapper" id={id}>
      <div className="question-header">
        <div>
          <span className="question">
            {order < 10 ? `0${order}` : order}. {question}
            <InfoCircleFilled className="info-icon" onClick={handleInfoClick} />
          </span>
        </div>
        <div className="sub-header-wrapper">
          {!has_question_subcategory &&
            (Object.keys(lastUpdated).length > 0 ||
              previous_submission[0]?.updated_at) && (
              <LastActivity
                updatedAt={
                  lastUpdated?.updatedAt || previous_submission[0]?.updated_at
                }
                qnId={id}
                category={null}
                {...rest}
              />
            )}
          <div style={{ display: "flex" }}>
            <Tooltip
              placement="bottomRight"
              overlayClassName={"ref-desctiption-tooltip"}
              title={infoTitle}
            >
              <ProfileOutlined className="ref-icon" />
            </Tooltip>
            <div className="reference-name">{refName}</div>
          </div>
        </div>
      </div>
      <CRRAnswerModule
        has_question_subcategory={has_question_subcategory}
        subcategories={subcategories}
        previous_submission={previous_submission}
        id={id}
        isAdminView={isAdminView}
        setAnswer={setAnswer}
        {...rest}
      />
      <DrawerComponent
        content={
          <QuestionInfo
            infoData={refDescription}
            question={question}
            questionNo={order < 10 ? `0${order}` : order}
            domain={submittedQnData?.domain_name}
            mil={submittedQnData?.mil}
            goal={submittedQnData?.goal}
          />
        }
        drawerVisible={isDrawerVisible}
        onClose={() => setIsDrawerVisible(false)}
        width={540}
      />
    </div>
  );
};

export default QuestionModule;
